export enum CalculationsTableColumnSize {
  VariableName = 31,
  CalculationCode = 69,
}
